import React from "react";
import { useTranslation } from "react-i18next";

const SupportInfoBlock = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="public-form__description-box">
        <p>
          {t("g4rDescriptionFirstLine")}
          <br />
          {t("g4rDescriptionSecondLine")}
        </p>
        <p>
          <a href={`tel:${t("g4rPhoneNumber")}`}>{t("g4rPhoneNumber")}</a>
          <br />
          <a href={`mailto:${t("g4rEmailAddress")}`}>{t("g4rEmailAddress")}</a>
        </p>
      </div>
    </>
  );
};

export default SupportInfoBlock;
